import React from 'react';
import PropTypes from 'prop-types';
import { INTRO_TEXT_WEB } from 'shared-modules/constants/omakasePlan';
import styles from './createOmakasePlanIntro.module.scss';
import { Spin } from '../../../../../components';
import OmakasePlanIcon from '../../../../../assets/selectionImages/omakase.svg';

export const CreateOmakasePlanIntro = ({ loading }) => {
  return loading ? (
    <Spin />
  ) : (
    <div className={styles.introContainer}>
      <img className={styles.imageIcon} src={OmakasePlanIcon} alt="OmakasePlan" />
      <div className={styles.introText}>{INTRO_TEXT_WEB}</div>
    </div>
  );
};

CreateOmakasePlanIntro.propTypes = {
  loading: PropTypes.bool,
};
CreateOmakasePlanIntro.defaultProps = {
  loading: false,
};
